import { formatExpiringDate } from "utils/formatExpiringDate";

export default function AccountExpiringDateBadge({ expiringDate, className = "" }) {
  const label = formatExpiringDate(expiringDate);
  const isMissing = label === "—";

  if (isMissing) {
    return (
      <span
        className={`shrink-0 text-sm font-semibold text-gray-400 dark:text-gray-500 ${className}`}
      >
        Expiration: —
      </span>
    );
  }

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-lg border-2 border-violet-300 bg-violet-50 px-3 py-1 text-sm font-bold text-violet-900 dark:border-violet-500/50 dark:bg-violet-500/15 dark:text-violet-100 ${className}`}
    >
      <span className="text-xs font-semibold uppercase tracking-wide text-violet-700 dark:text-violet-300">
        Expiration
      </span>
      <span className="tabular-nums">{label}</span>
    </span>
  );
}
